export default function CouponSection() {
  const coupons = [
    { code: "WELCOME10", desc: "10% off your first order for new Sugargoo users", type: "New User" },
    { code: "SPREADSHEET5", desc: "$5 discount on orders over $50 when using our spreadsheet links", type: "Exclusive" },
    { code: "SEASON2026", desc: "Seasonal promotion with up to 15% off selected categories", type: "Seasonal" },
    { code: "SHIPFREE", desc: "Free shipping coupon on qualifying international orders", type: "Shipping" },
  ];

  return (
    <section className="py-16 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold uppercase tracking-wider mb-4">
            Exclusive Deals
          </span>
          <h2 className="text-2xl md:text-4xl font-bold font-heading text-foreground-950 mb-4">
            Sugargoo Coupon &amp; <span className="text-primary-500">Discount Code Center</span>
          </h2>
          <p className="text-foreground-600 max-w-2xl mx-auto leading-relaxed">
            Save money on every purchase with verified Sugargoo coupon codes and discount offers. We regularly update this section with the latest promotions and exclusive deals for our community.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-10">
          {coupons.map((c) => (
            <div
              key={c.code}
              className="flex items-start gap-4 p-5 rounded-lg bg-background-50 border border-background-200/70 hover:border-primary-200 transition-colors"
            >
              <div className="w-12 h-12 flex-shrink-0 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600">
                <i className="ri-coupon-line text-xl"></i>
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1 flex-wrap">
                  <span className="text-sm font-bold font-mono text-primary-600">{c.code}</span>
                  <span className="px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-700 text-[10px] font-semibold uppercase">
                    {c.type}
                  </span>
                </div>
                <p className="text-sm text-foreground-600 leading-relaxed">{c.desc}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-primary-500 text-white hover:bg-primary-600 text-sm font-semibold transition-all cursor-pointer whitespace-nowrap"
          >
            Get Latest Offers
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}